<script setup>

const { t } = useI18n()

const props = defineProps({
  title: {
    type: String
  },
	date: {
		type: String
	},
	type: {
		type: String
	},
	podcastSection: {
		type: String,
		default: ''
	}
})

const getTypeTitle = () => {
	switch (props.type) {
		case 'Article':
			return t('tag.news')
		case 'Podcast':
			return props.podcastSection
		case 'Release':
			return t('tag.new-release')
		default:
			return ""
	}
}

const getColor = () => {
	switch (props.type) {
		case 'Article':
			return 'red'
		case 'Podcast':
			return 'magenta'
		case 'Release':
			return 'green'
		default:
			return "red"
	}
}

</script>

<template>
	<div class="dark:text-light text-center">
		<h1 v-html="title" class="mb-5 xl:mb-10" />
		<h4>
			<span>{{ useFormatDate(date) }}</span>
			—
			<span :class="`text-${getColor()}`">{{ getTypeTitle() }}</span>
		</h4>
	</div>
</template>